<template>
  <div>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-img
          height="600px"
          src="./../../assets/images/Mask Group 15/Mask Group 15.png"
        >
          <v-layout justify-center wrap pt-16>
            <v-flex xs12 sm12 md8 pa-2>
              <v-layout justify-center wrap>
                <v-flex xs12 sm6 md6>
                  <span class="footerHead">Let's talk.</span>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <span
                    style="
                      color: #ffffff;
                      font-family: MontserratSemiBold;
                      font-size: 25px;
                    "
                    >DMAAC</span
                  >
                </v-flex>
                <v-flex xs12>
                  <v-layout justify-center wrap pt-10>
                    <v-flex xs12>
                      <span class="footersubHead">info@dmaac.com</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-layout justify-center wrap>
                    <v-flex xs12 pt-10>
                      <span
                        style="color: #868686; font-family: ibmplexsansregular"
                        >Dmaac, ABC Suite, <br />
                        2nd Lane, UK</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6 md6 pt-10>
                  <v-layout justify-center wrap>
                    <v-flex xs6 py-2 v-for="(item, i) in items" :key="i">
                      <span class="footerItem">{{ item }}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-img>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab1: null,
      items: [
        " Services",
        "Customer Stories",
        "About Us",
        "Blog",
        "Why DMAAC",
        "Contact Us",
      ],
    };
  },
};
</script>